import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { icons } from "../../../constants";
import SimpleTable from "../../../components/tables/simpleTable";
import { useLoadingState } from "../../../components/loadingFeedback";
import { openClosedSelect } from "../../../constants/selectData";
import {
  callApiAsync,
  getServiceOrderTableData
} from "../../../services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { hasAnyRoleUtil } from "../../../services/roleService";
import { statesServiceOrderEnum } from "../../../constants/enums";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useNavigate } from "react-router-dom";
import { setServiceOrderId } from "../../../redux/slices/serviceOrderSlice";
import { useForm } from "react-hook-form";
import { formatCustomDate } from "../../../services/dateService";
import { BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES } from "../../../constants/biomedicalRoles";

const OpenClosedindicatorTable = ({ filterList }) => {
  const { control, getValues, reset } = useForm({
    defaultValues: { openClosed_state: null }
  });
  const userData = useSelector((state) => state.userData.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isServiceOrderManagment = hasAnyRoleUtil(
    BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES,
    userData.roleList
  );
  const isReadOnlyServiceOrder = !isServiceOrderManagment;

  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const applyBaseFilters = (data, filters) => {
    if (!filters) return data;

    const {
      activity,
      engineer,
      institution,
      month,
      year
    } = filters; 

    return data.filter((item) => {
      const matchesActivity = activity ? item.activity_id === activity : true;
      const matchesEngineer = engineer ? item.engineer_id === engineer : true;

     
      const instVal = Array.isArray(institution) ? institution[0] : institution;
      const matchesInstitution = instVal
        ? item.institution_id === instVal
        : true;

      const d = new Date(item.creation_date);
      const matchesMonth = month ? d.getMonth() + 1 === month : true;
      const matchesYear = year ? d.getFullYear() === year : true;

      return (
        matchesActivity &&
        matchesEngineer &&
        matchesInstitution &&
        matchesMonth &&
        matchesYear
      );
    });
  };

  const handleFilter = () => {
  const form = getValues();
  const stateVal = form.openClosed_state;

  let filtered = applyBaseFilters(originalData, filterList);

  if (stateVal) {
    filtered = filtered.filter((item) =>
      stateVal === 1
        ? item.state !== statesServiceOrderEnum.Completed 
        : item.state === statesServiceOrderEnum.Completed 
    );
  }

  setTableData(filtered);
};

const handleClearFilters = () => {
  reset({ openClosed_state: null }); 
  const base = applyBaseFilters(originalData, filterList);
  setTableData(base);
};

  const columns = [
    { field: "service_order_name", header: "ORDEN DE SERVICIO", columnWidth: "150px" },
    {
    field: "creation_date",
    header: "Fecha de creación",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {formatCustomDate(rowData.creation_date)}
      </p>
    ),
    columnWidth: "130px"
  },
    { field: "engineer_name", header: "Ingeniero" },
    { field: "institution_name", header: "Institución" },
    {
      field: "state",
      header: "Estado",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {rowData.state === statesServiceOrderEnum.Completed
            ? "Cerrada"
            : "Abierta"}
        </p>
      )
    },
    { field: "actionButtons", columnType: "actionButtons" }
  ];

  const buttons = [
    {
      type: "icon",
      icon: icons.eye,
      onClick: (rowData) => {
        dispatch(setServiceOrderId(rowData.service_order_id));
        navigate(
          "/biomedicalManagementDashboard/BioMedicalRequest/createRequest"
        );
      }
    }
  ];

  const [loadingTable, setLoadingTable] = useLoadingState(true);
  const getServiceOrdersAnualChart = async () => {
    await callApiAsync(
      () =>
        getServiceOrderTableData(
          userData.id,
          isReadOnlyServiceOrder
            ? isReadOnlyServiceOrder
            : isServiceOrderManagment
        ),
      (data) => {
        setOriginalData(data);
        const base = applyBaseFilters(data, filterList);
        setTableData(base);
      },
      setLoadingTable
    );
  };

  useEffect(() => {
    getServiceOrdersAnualChart();
  }, []);


  useEffect(() => {
    const base = applyBaseFilters(originalData, filterList);
    setTableData(base);
  }, [filterList]);

  return (
    <div>
      <form style={{ display: "flex", alignItems: "center" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <SimpleSelect
              name="openClosed_state"
              control={control}
              label="Estado"
              options={openClosedSelect}
              margin="0"
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <div className="IHContainer j-end">
              <LaddaButton
                variant="contained"
                onClick={handleFilter}
                margin="0"
                width="52px"
              >
                <img className="btn-icon" src={icons.filterWhite} alt="icon" />
              </LaddaButton>
              <LaddaButton
                variant="contained"
                onClick={handleClearFilters}
                margin="0 -1px 0 5px"
                width="52px"
              >
                <img
                  className="btn-icon"
                  src={icons.clearFilterWhite}
                  alt="icon"
                />
              </LaddaButton>
            </div>
          </Grid>
        </Grid>
      </form>

      <br className="br-white-space" />

      <SimpleTable
        loading={loadingTable}
        data={tableData}
        columns={columns}
        text={"Realizar Autoevaluación"}
        isPaginated={true}
        sortable
        buttons={buttons}
      />
    </div>
  );
};

export default OpenClosedindicatorTable;
